export enum DataserverApiEndpoint {
    // auth
    GetLoginTokenFromBadgeId = 'get-login-token-from-badge-id',
    GetLoginTokenForDashboard = 'get-login-token-for-dashboard',
    GetLoginTokenForClientDevice = 'get-login-token-for-client-device',
    GetDeviceIpAddress = 'get-device-ip-address',

    // utility
    Ping = 'ping',
    CheckIfIAmClientDevice = 'check-if-i-am-client-device',

    // printing
    PrintLabel = 'print-label',

    // motionmaster (Fagor 8050 M router, via the Mac mini bridge on the shop LAN)
    MotionmasterStatus = 'status',
    MotionmasterDirectory = 'directory',
    MotionmasterProgram = 'program',
    MotionmasterToolpath = 'toolpath',
    MotionmasterSelectProgram = 'select-program',
    MotionmasterStartProgram = 'start-program',
    MotionmasterStopProgram = 'stop-program',

    // storage-backup
    SeedStorageBackupQueue = 'seed-storage-backup-queue',
    RunStorageBackup = 'run-storage-backup',
    CopyStorageToStaging = 'copy-storage-to-staging',
};
